<div
  class="col-12"
  *ngIf="isLoading"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  "
>
  <app-progress></app-progress>
</div>

<div class="page_header">
  <h1 class="heading">Annual Compliance Certificates List</h1>
</div>
<div class="row">
  <div class="col">
    <app-filter
      [formConfig]="filterConfig"
      (formValueChanged)="applyFilter($event)"
      [selectedItems]="selectedItems"
    ></app-filter>
  </div>
</div>
<div class="table-responsive">
  <table class="table custom_table" cellspacing="0" width="100%">
    <thead>
      <tr>
        <th></th>
        <th>
          Permit Number
          <!-- <i
            class="fa fa-sort"
            [ngClass]="{
              'fa-sort-asc sort-a': utility.flags.flagPN == 2,
              'fa-sort-desc sort-d': utility.flags.flagPN == 3,
              'fa-sort': utility.flags.flagPN == 1
            }"
            (click)="utility.onSort(11)"
          >
          </i> -->
        </th>

        <th>
          Permit Type
          <!-- <i
            class="fa fa-sort"
            [ngClass]="{
              'fa-sort-asc sort-a': utility.flags.flagPT == 2,
              'fa-sort-desc sort-d': utility.flags.flagPT == 3,
              'fa-sort': utility.flags.flagPT == 1
            }"
            (click)="utility.onSort(11)"
          >
          </i> -->
        </th>

        <th class="permit_type">
          Carrier
          <!-- <i
            class="fa fa-sort"
            [ngClass]="{
              'fa-sort-asc sort-a': utility.flags.flageCD == 2,
              'fa-sort-desc sort-d': utility.flags.flageCD == 3,
              'fa-sort': utility.flags.flageCD == 1
            }"
            (click)="utility.onSort(9)"
          ></i> -->
        </th>
        <th>
          Vehicle
          <!-- <i
            class="fa fa-sort"
            [ngClass]="{
              'fa-sort-asc sort-a': utility.flags.flagRN == 2,
              'fa-sort-desc sort-d': utility.flags.flagRN == 3,
              'fa-sort': utility.flags.flagRN == 1
            }"
            (click)="utility.onSort(10)"
          ></i> -->
        </th>
        <th class="text-right">
          <div class="flex_center">
            <span class="txt">Compliance Due Date</span>
            <i
              class="fa fa-sort"
              [ngClass]="{
                'fa-sort-asc sort-a': utility.flags.flagDD == 2,
                'fa-sort-desc sort-d': utility.flags.flagDD == 3,
                'fa-sort': utility.flags.flagDD == 1
              }"
              (click)="utility.onSort(12)"
            ></i>
          </div>
        </th>
        <th>Year#</th>
        <th class="text-right">Submission Date</th>
        <!-- <th>
          <div class="flex_center">
            <span class="txt">Application Number</span>
            <i class="fa fa-sort"></i>
          </div>
        </th> -->
        <th>First or Dup</th>
        <th class="text-right">Fee</th>
        <th>Invoice</th>
        <th>
          Status
          <i
            class="fa fa-sort"
            [ngClass]="{
              'fa-sort-asc sort-a': utility.flags.flagST == 2,
              'fa-sort-desc sort-d': utility.flags.flagST == 3,
              'fa-sort': utility.flags.flagST == 1
            }"
            (click)="utility.onSort(8)"
          ></i>
        </th>
        <th>Face value#</th>
        <th class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="
          let data of annualComplianceListData
            | orderBy : utility.criteria : utility.direction
            | paginate
              : {
                  itemsPerPage: pageSize,
                  currentPage: currentPage,
                  totalItems: count
                };
          let i = index
        "
      >
        <td>
          <input
            type="checkbox"
            style="
              margin-right: 7px;
              margin-top: -2px;
              display: inline-block;
              vertical-align: middle;
            "
          />
        </td>
        <td>{{ data?.permit_num }}</td>
        <td>{{ data?.permit_type }}</td>
        <td>{{ data?.carrier_code }}</td>
        <td class="no_wrap">{{ data?.registration_number }}</td>
        <td class="text-right no_wrap">
          {{ data?.date_ac_due | date : "dd/MM/YYYY" }}
        </td>
        <td>{{ data?.year_num }}</td>
        <td class="text-right no_wrap">
          {{
            (data?.date_submitted | date : "dd/MM/YYYY")
          }}
        </td>
        <!-- <td>H123476</td> -->
        <td>
          {{ data?.Is_duplicate == false ? "First" : "Duplicate" }}
        </td>
        <td class="text-right">
          {{ data?.line_total != null ? data?.line_total : "N/A" }}
        </td>
        <td class="no_wrap">
          {{
            data?.compliance_invoice_link != null
              ? data?.compliance_invoice_link
              : "N/A"
          }}
        </td>
        <td class="active">
          {{ data.compliance_status != null ? data.compliance_status : "N/A" }}
        </td>
        <td class="">
          {{ data.face_value_num != null ? data.face_value_num : "N/A" }}
        </td>
        <td class="text-center">
          <div class="user-action-wrap dropdown">
            <a
              href="#actionMenu"
              data-toggle="dropdown"
              class="dropdown-toggle spacer-x opensans-semi-bold-black-16px"
              role="button"
            >
              <img
                class="personcropcircle"
                src="../../../assets/dotIcon.png"
                alt="person.crop.circle"
              />
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
              <li>
                <a (click)="onViewPermit(data)">View Permit</a>
              </li>
              <li>
                <a (click)="onViewDetails(data)"> Process Application </a>
              </li>
              <li>
                <a (click)="onViewApplication(data)">
                  Print/Change Status
                </a>
              </li>
            </ul>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr class="pagination_row">
        <td colspan="8" class="rm-brd">
          <div class="row">
            <div class="col-4" *ngIf="!isEmpty">
              <div
                class="input-group mb-3 rm-brd"
                style="width: 125px !important; height: 30px !important"
              >
                <div class="input-group-prepend">
                  <label
                    class="input-group-text form-control-sm show-h"
                    for="show-id"
                    >Show:</label
                  >
                </div>
                <select
                  class="form-control form-control-sm show-h"
                  id="show-id"
                  [(ngModel)]="pageSize"
                  (change)="onChange(pageSize)"
                >
                  <option *ngFor="let key of utility.pageItems" [ngValue]="key">
                    {{ key }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-8 text-right" *ngIf="!isEmpty">
              <pagination-controls
                (pageChange)="utility.page = onNextOrPrevious($event)"
                style="
                  margin-left: 0px !important;
                  padding-left: 0px !important;
                "
              ></pagination-controls>
            </div>
          </div>
        </td>
      </tr>
      <tr *ngIf="isEmpty">
        <td colspan="8" class="rm-brd text-center">
          <span class="text-info text-small"
            >No Annual Compliance Data found.</span
          >
        </td>
      </tr>
    </tfoot>
  </table>
</div>
